import React, { Component } from 'react';
import { Row, Col, Panel, Modal, Button, Nav, NavItem } from 'react-bootstrap'
import { connect } from 'react-redux'

import NavHeader from './navheader'
import { checkoutOmise, createOrder, updateCartProducts, checkCartProductsPrice, setPaymentStage, setDeliveryTime, createCustomerOmise, getCreditCardByPhoneNumber, clearCreditCard, clearCheckPriceResponse, updateCartExtraProducts } from '../actions'
import { getMoneyFormat } from '../utils'
import SubMenu from './submenu'
import Footer from './footer'
import ComponentCreditCardInput from './component_credit_card_input'
import Lightbox from 'react-images';
import Stepper from 'react-stepper-horizontal';
import _ from 'lodash'

class PagePayment extends Component {

    constructor() {
        super();
        this.closeLightbox = this.closeLightbox.bind(this);
        this.openLightbox = this.openLightbox.bind(this);
    }

    state = {
        tabSelect: '3',
        name: '',
        input1: '',
        input2: '',
        input3: '',
        input4: '',
        input5: '',
        input6: '',
        input7: '',
        isLogin: false,
        loading: false,
        payment_method: '',
        edit_credit_card: false,
        loading_credit_card: true,
        lightboxIsOpen: false,
        showModal: true,
    }

    componentWillMount() {
        // window.Omise.setPublicKey('pkey_test_59lploy0m5cf9rpatre');
        if (localStorage.getItem('user') != null) {
            this.setState({ isLogin: true })
            if (_.isEmpty(JSON.parse(localStorage.getItem('cart_products'))) || JSON.parse(localStorage.getItem('cart_products')) == null) {
                window.alert('ไม่มีรายการสินค้า')
                this.props.history.push('/')
            } else {
                if (this.props.payment_stage == 'payment') {
                    // this.props.getCreditCardByPhoneNumber((JSON.parse(localStorage.getItem('user')).phone_number), this.callbackGetCard.bind(this), this.callbackErr.bind(this))
                } else {
                    this.props.setPaymentStage('idle')
                    this.props.history.push('/order_review')
                }
            }
        } else {
            this.props.history.push('/login')
        }
        this.handleChange('3')
        window.scrollTo(0, 0)
    }

    componentWillReceiveProps(nextProps) {
        if (!_.isEmpty(nextProps.customer_credit_card) &&
            JSON.stringify(nextProps.customer_credit_card) != JSON.stringify(this.props.customer_credit_card)) {
            this.setState({ loading_credit_card: false })
        }
        if (!_.isEmpty(nextProps.check_cart_products_price_response)
            && nextProps.check_cart_products_price_response != this.props.check_cart_products_price_response
            && JSON.stringify(nextProps.cart_products) == JSON.stringify(this.props.cart_products)
            && nextProps.payment_stage == this.props.payment_stage
            && nextProps.delivery_time == this.props.delivery_time
        ) {
            if (nextProps.check_cart_products_price_response.success) {
                let user_info = JSON.parse(localStorage.getItem('user'))
                let address = user_info.address.address1
                let real_address = ''
                real_address += ' ' + address.residential_type
                address.building ? real_address += ' ' + address['building'] : ''
                real_address += ' เลขที่: ' + address['house_number']
                address.room_number ? real_address += ' ' + address['room_number'] : ''
                address.floor ? real_address += ' ' + address['floor'] : ''
                address.road ? real_address += ' ถนน: ' + address['road'] : ''
                address.alley ? real_address += ' ' + address['alley'] : ''
                real_address += ' ' + address['zip_code']
                real_address += ' ' + address['district']
                real_address += ' ' + address['area']
                real_address += ' ' + address['province']
                address.landmark ? real_address += ' จุดสังเกต: ' + address['landmark'] : ''

                let token = user_info.token
                let value = {}
                value['money_received'] = this.getFinalPrice()
                value['promocode'] = this.props.discount.promocode
                value['customer_address'] = this.props.delivery_charge.drivethru == null ? real_address : 'ตลาดดอนกลาง'
                if ((this.props.delivery_time).split(';').length > 1) {//preorder
                  //value['preorderTime'] = (this.props.delivery_time).split(';')[0]
                     //value['preorder'] = true
                     //value['delivery_time_even'] = (this.props.delivery_time).split(';')[0]
                     value['even']=true
                     value['delivery_time'] = (this.props.delivery_time).split(' ')[0]
                } else {
                    value['delivery_time'] = (this.props.delivery_time).split(' ')[0]
                }
                // console.log((this.props.delivery_time).split(' ')[0])
                value['delivery_charge'] = this.props.delivery_charge.delivery_fee
                let today = new Date()
                value['delivery_tmr'] = (this.props.delivery_time).split(' ')[2] != today.getDate() ? true : false
                value['products'] = {}
                value['extraproducts'] = {}
                _.map(this.props.cart_products, product => {
                    if (product.product_description) {
                        value['products'][product.product_id] = { request_unit: product.product_amount, product_description: product.product_description }
                    } else {
                        value['products'][product.product_id] = { request_unit: product.product_amount }
                    }
                })
                _.map(this.props.cart_extraproducts, product => {
                    if (product.product_description) {
                        value['extraproducts'][product.product_id] = {
                            product_name: product.product_name,
                            product_price_unit: product.price_unit,
                            product_unit: product.product_unit,
                            product_description: product.product_description,
                            request_unit: product.product_amount
                        }
                    } else {
                        value['extraproducts'][product.product_id] = {
                            product_name: product.product_name,
                            product_price_unit: product.price_unit,
                            product_unit: product.product_unit,
                            request_unit: product.product_amount
                        }
                    }
                })
                value['payment_method'] = this.state.payment_method
                // console.log('value_top', value, 'token', token)
                this.props.createOrder(value, token, this.createOrderCallback.bind(this), this.createOrderCallbackErr.bind(this))
            } else {
                let values = JSON.parse(JSON.stringify(this.props.cart_products))
                let products_changed = nextProps.check_cart_products_price_response.data.products
                _.map(products_changed, product => {
                    if (product.is_out_of_stock == true) {
                        delete values[product.id]
                    } else {
                        values[product.id]['product_price_unit'] = product.product_price_unit
                    }
                })
                // console.log('values edit', values)
                this.props.updateCartProducts(values)
                window.alert('สินค้าในตะกร้ามีารเปลี่ยนแปลงราคา หรือ หมดชั่วคราว กรุณาตรวจสอบรายการสินค้าในตะกร้าอีกครั้ง')
                this.props.history.push('/order_review')
            }
        }
    }

    componentWillUnmount() {
        this.props.clearCreditCard()
        this.props.clearCheckPriceResponse()
    }

    openLightbox(event, obj) {
        this.setState({
            currentImage: obj.index,
            lightboxIsOpen: true,
        });

    }
    closeLightbox() {
        this.setState({
            currentImage: 0,
            lightboxIsOpen: false,
        });
    }

    callbackErr() {
        window.alert('เกิดข้อผิดพลาด กรุณาทำรายการใหม่อีกครั้ง')
        this.props.history.push('/')
    }

    callbackGetCard() {
        this.setState({ loading_credit_card: false })
    }

    checkPrice() {
        let token = (JSON.parse(localStorage.getItem('user'))).token
        let products = { products: { ...this.props.cart_products } }
        this.props.checkCartProductsPrice(products, token, this.callbackErr.bind(this))
    }

    getFinalPrice() {
        return Math.round(this.getTotalProductPrice() + this.props.delivery_charge.delivery_fee - (this.props.discount.value || 0))
    }

    // getTotalReserve() {
    //     let total_reserve = 0
    //     _.map(this.props.cart_products, product => {
    //         total_reserve += product.product_price_unit * product.product_amount * (product.product_reserve_factor)
    //     })
    //     // return Number(total_reserve.toFixed(2))
    //     return 0
    // }

    getTotalProductPrice() {
        let total_price = 0
        _.map(this.props.cart_products, product => {
            total_price += product.product_price_unit * product.product_amount
        })
        return Number(total_price.toFixed(2))
    }

    handleSelect(eventKey) {
        eventKey.preventDefault()
        this.setState({ tabSelect: eventKey })
    }

    handleChange(e) {
        this.setState({ tabSelect: e, showModal: false })
    }

    renderTab() {
        // let color1 = this.state.tabSelect == '1' ? '#6ac259' : ''
        let color2 = this.state.tabSelect == '2' ? '#6ac259' : ''
        let color3 = this.state.tabSelect == '3' ? '#6ac259' : ''
        return (
            <div>
                <br />
                <Row>
                    {/* <Col xs={4} sm={4} md={4} lg={4}>
                        <Panel style={{ cursor: 'pointer', borderColor: color1 }} onClick={() => { this.handleChange('1') }}>
                            {this.state.tabSelect == '1' ?
                                <img style={{ display: 'inline-block' }} src='../../static/images/checked.png' style={{ width: 25, marginRight: 8 }} />
                                :
                                <img style={{ display: 'inline-block' }} src='../../static/images/checked02.png' style={{ width: 25, marginRight: 8 }} />}
                            <h5 className='hidden-xs' style={{ display: 'inline-block' }}>ชำระผ่านบัตรเครดิต</h5>
                            <h6 className='hidden-sm hidden-md hidden-lg' style={{ display: 'inline-block', fontFamily: 'kanit', paddingTop: 2, paddingBottom: 1 }}>ชำระผ่านบัตรเครดิต</h6>
                        </Panel>
                    </Col> */}
                    <Col xs={12} sm={12} md={12} lg={12}>
                        
                        <Panel style={{ cursor: 'pointer', borderColor: color3 }} onClick={() => { this.handleChange('3') }}>
                        {this.state.tabSelect == '3' ?
                                <img style={{ display: 'inline-block' }} src='../../static/images/checked.png' style={{ width: 25, marginRight: 8 }} />
                                :
                                <img style={{ display: 'inline-block' }} src='../../static/images/checked02.png' style={{ width: 25, marginRight: 8 }} />}
                            <h5 className='hidden-xs' style={{ display: 'inline-block' }}>ชำระผ่านการโอนเงิน</h5>
                            <h6 className='hidden-sm hidden-md hidden-lg' style={{ display: 'inline-block', fontFamily: 'kanit', paddingTop: 2, paddingBottom: 1 }}>ชำระผ่านการโอนเงิน</h6>
                        </Panel>

                        {/* <Panel style={{ cursor: 'pointer', borderColor: color2 }} onClick={() => { this.handleChange('2') }}>
                            {this.state.tabSelect == '2' ?
                                <img style={{ display: 'inline-block' }} src='../../static/images/checked.png' style={{ width: 25, marginRight: 8 }} />
                                :
                                <img style={{ display: 'inline-block' }} src='../../static/images/checked02.png' style={{ width: 25, marginRight: 8 }} />}
                            <h5 className='hidden-xs' style={{ display: 'inline-block' }}>ชำระผ่านทาง QR Code</h5>
                            <h6 className='hidden-sm hidden-md hidden-lg' style={{ display: 'inline-block', fontFamily: 'kanit', paddingTop: 2, paddingBottom: 1 }}>ชำระผ่านทาง QR Code</h6>
                        </Panel> */}
                    </Col>
                    {/* <Col xs={6} sm={6} md={6} lg={6}>
                        <Panel style={{ cursor: 'pointer', borderColor: color2 }} onClick={() => { this.handleChange('2') }}>
                            {this.state.tabSelect == '2' ?
                                <img style={{ display: 'inline-block' }} src='../../static/images/checked.png' style={{ width: 25, marginRight: 8 }} />
                                : <img style={{ display: 'inline-block' }} src='../../static/images/checked02.png' style={{ width: 25, marginRight: 8 }} />}
                            <h5 style={{ display: 'inline-block' }}>ชำระเงินปลายทาง</h5>
                        </Panel>
                    </Col> */}
                </Row>
            </div>
        )
    }

    createOrderCallback(orderId) {
        this.setState({ loading: false, edit_credit_card: false })
        localStorage.removeItem('cart_products')
        localStorage.removeItem('extracart_products')
        this.props.updateCartProducts({})
        this.props.updateCartExtraProducts({})
        this.props.setDeliveryTime('')
        this.props.history.push('/finished_order')
    }

    createOrderCallbackErr(err) {
        console.log(err)
        this.setState({ loading: false, edit_credit_card: false })
        window.alert('เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง')
    }

    omiseCreateCustomer(values) {
        this.props.createCustomerOmise(values, this.omiseCreateCustomerCallback.bind(this), this.omiseCreateCustomerCallbackErr.bind(this))
    }

    omiseCreateCustomerCallback() {
        this.checkPrice()
    }

    omiseCreateCustomerCallbackErr(message) {
        this.setState({
            loading: false, name: '', input1: '', input2: '', input3: '',
            input4: '', input5: '', input6: '', input7: ''
        })
        window.alert('ไม่สามารถชำระเงินผ่านบัตรเครดิตได้กรุณากรอกข้อมูลอีกครั้ง: ' + message)
    }

    onCreateCustomerCreditCard() {
        let bool = true
        let values = {}
        this.state.name != '' ? values = { name: this.state.name } : bool = false
        for (let i = 1; i < 5; i++) {
            let state = 'input' + i
            this.state[state].length == 4 ? '' : bool = false
        }
        for (let i = 5; i < 7; i++) {
            let state = 'input' + i
            this.state[state].length == 2 ? '' : bool = false
        }
        this.state.input7.length == 3 ? '' : bool = false
        if (bool) {
            values['number'] = this.state.input1 + this.state.input2 + this.state.input3 + this.state.input4
            values['expiration_month'] = this.state.input5
            values['expiration_year'] = this.state.input6
            values['security_code'] = this.state.input7

            this.omiseCreateToken(values)
        } else {
            window.alert('กรุณากรอกข้อมูลให้ครบถ้วนถูกต้อง')
            this.setState({ loading: false })
        }
    }

    onCheckoutCreditCard(is_have_card) {
        if (is_have_card) {
            this.setState({ loading: true, payment_method: 'CREDITCARD' })
            this.checkPrice()
        } else {
            this.setState({ loading: true, payment_method: 'CREDITCARD' })
            this.onCreateCustomerCreditCard()
        }
    }

    omiseCreateToken(credit_card_values) {
        window.Omise.createToken('card', credit_card_values, (statusCode, response) => {
            if (statusCode === 200) {
                // Success: send back the TOKEN_ID to your server. The TOKEN_ID can be
                // found in `response.id`.
                // checkoutForm.omiseToken.value = response.id;
                // checkoutForm.submit();
                // console.log(response.id);
                // let value_to_sent = { omiseToken: response.id, amount: (this.getFinalPrice() * 100), orderId: this.state.orderId }
                let user_info = JSON.parse(localStorage.getItem('user'))
                let values = { card: response.id, description: user_info.phone_number, email: user_info.email }
                // this.props.checkoutOmise(value_to_sent, this.checkoutOmiseCallback.bind(this), this.checkoutOmiseCallbackErr.bind(this))
                this.omiseCreateCustomer(values)
            } else {
                // Error: display an error message. Note that `response.message` contains
                // a preformatted error message. Also note that `response.code` will be
                // "invalid_card" in case of validation error on the card.
                // console.log('resp', response)
                window.alert('ไม่สามารถชำระเงินผ่านบัตรเครดิตได้กรุณากรอกข้อมูลอีกครั้ง: ' + response.message)
                this.setState({
                    loading: false, name: '', input1: '', input2: '', input3: '',
                    input4: '', input5: '', input6: '', input7: ''
                })
            }
        })
    }

    setParentState(key, value) {
        let newState = {}
        newState[key] = value
        this.setState({ ...newState })
    }

    renderHaveCard() {
        return (
            <div className="panel panel-default" style={{ marginTop: 15 }}>
                <div className="panel-body">
                    <h3 className="panel-title" style={{ marginTop: 5, fontSize: 25 }}><strong>ชำระผ่านบัตรเครดิต</strong></h3>
                    <img className="img-responsive pull-right" style={{ marginTop: -30, height: 40 }} src="../static/images/card_logo.png" />
                    <h4 style={{ paddingTop: 10 }}>ข้อมูลบัตรเครดิตเดิม</h4>
                    <h4>name: {this.props.customer_credit_card.data ? ((this.props.customer_credit_card.data.cards.data)[0]).name : ''}</h4>
                    <h4>card number: XXXX-XXXX-XXXX-{this.props.customer_credit_card.data ? ((this.props.customer_credit_card.data.cards.data)[0]).last_digits : ''}</h4>
                    <h4>expiration: {this.props.customer_credit_card.data ? ((this.props.customer_credit_card.data.cards.data)[0]).expiration_month + ' / ' + String(((this.props.customer_credit_card.data.cards.data)[0]).expiration_year).substring(2, 4) : ''}</h4>
                    <br />
                    {this.state.loading == false ? <div>
                        <button onClick={() => { this.onCheckoutCreditCard(true) }} style={{ marginTop: 10, width: '48%', height: 40 }} className='btn btn-success pull-right' >สั่งซื้อสินค้า</button>
                        <button onClick={() => { this.setState({ edit_credit_card: true }) }} style={{ marginTop: 10, width: '48%', height: 40 }} className='btn btn-success pull-left' >แก้ไขข้อมูลบัตรเครดิต</button>
                    </div>
                        : <div className='loader'></div>
                    }
                </div>
            </div>
        )
    }

    renderNotHaveCard() {
        return (
            <div className="panel panel-default" style={{ marginTop: 15 }}>
                <div className="panel-body">
                    <h3 className="panel-title" style={{ marginTop: 5, fontSize: 18 }}><strong>ชำระผ่านบัตรเครดิต</strong></h3>
                    <img className="img-responsive pull-right" style={{ marginTop: -30, height: 40 }} src="../static/images/card_logo.png" />
                    <p style={{ marginTop: 10 }}>กรุณากรอกข้อมูลบัตรเครดิต เพื่อทำการชำระเงินผ่านบัตรเครดิต โดยข้อมูลของท่านจะถูกเก็บเป็นความลับ</p>
                    <ComponentCreditCardInput setParentState={this.setParentState.bind(this)}
                        input1={this.state.input1} input2={this.state.input2}
                        input3={this.state.input3} input4={this.state.input4}
                        input5={this.state.input5} input6={this.state.input6}
                        input7={this.state.input7} name={this.state.name}
                    />
                    {this.state.loading == false ?
                        <button onClick={() => { this.onCheckoutCreditCard(false) }} style={{ marginTop: 10, width: 200, height: 40 }} className='btn btn-success pull-right' >สั่งซื้อสินค้า</button>
                        : <div className='loader'></div>
                    }
                </div>
            </div>
        )
    }

    renderForm() {
        const { handleSubmit } = this.props
        if (this.state.tabSelect == '1') {
            if (this.state.loading_credit_card) {
                return <div className='loader'></div>
            } else {
                return (
                    <div>
                        <h5 style={{ textAlign: 'center' }}>หมายเหตุ</h5>
                        <h5 style={{ textAlign: 'center', color: '#696969' }}>"ราคาสินค้าอาจมีการเปลี่ยนแปลง *และยังไม่รวมค่าจัดส่ง อย่าเพิ่งโอนเงิน กรุณารอการติดต่อกลับ เพื่อสรุปยอดอีกครั้งจากทางเรา"</h5>
                        {_.isEmpty(this.props.customer_credit_card) || this.state.edit_credit_card ?
                            this.renderNotHaveCard()
                            :
                            this.renderHaveCard()
                        }

                    </div>
                )
            }
        }
        if (this.state.tabSelect == '2') {
            return (
                // <Panel>
                //     {this.state.loading == false ?
                //         this.getFinalPrice() + 40 <= 1000 ?
                //             <div>
                //                 <h3><strong>ชำระเงินปลายทาง</strong></h3>
                //                 <h4 style={{ color: '#f57224 !important', marginTop: 20, marginBottom: 20, textAlign: 'center' }}>"รอการติดต่อกลับจากเราอีกครั้ง กรุณาเตรียมจำนวนเงินให้พอดี"</h4>
                //                 <h4>การชำระเงินปลายทางมีค่าบริการเพิ่มเติม 40 บาท</h4>
                //                 <h4>ดังนั้นยอดทั้งหมดจะเท่ากับ {getMoneyFormat((this.getFinalPrice() + 40).toFixed(2))} บาท</h4>
                //                 <h5 style={{ textAlign: 'center' }}>หมายเหตุ</h5>
                //                 <h5 style={{ textAlign: 'center', color: '#696969' }}>"ราคาสินค้าอาจมีการเปลี่ยนแปลง *และยังไม่รวมค่าจัดส่ง อย่าเพิ่งโอนเงิน  กรุณารอการติดต่อกลับ เพื่อสรุปยอดอีกครั้งจากทางเรา"</h5>
                //                 <button style={{ marginTop: 10, width: 200, height: 40 }} className='btn btn-success pull-right' onClick={() => { this.createOrderCT('COD') }}>สั่งซื้อสินค้า</button>
                //             </div>
                //             : <div><h3 style={{ color: 'red', textAlign: 'center' }}>ขออภัยในความไม่สะดวก</h3><h4 style={{ textAlign: 'center' }}>ยอดสินค้าเกิน 1,000 บาท ไม่สามารถใช้บริการชำระเงินปลายทางได้ค่ะ</h4><h4 style={{ textAlign: 'center' }}>กรุณาเลือกชำระผ่านการโอนเงิน</h4></div>
                //         : <div className='loader'></div>
                //     }
                // </Panel>

                <Panel>
                    <h4 style={{ color: '#f57224 !important', marginTop: 20, marginBottom: 20, textAlign: 'center' }}>"ราคาสินค้าอาจมีการเปลี่ยนแปลง *และยังไม่รวมค่าจัดส่ง อย่าเพิ่งโอนเงิน กรุณารอการติดต่อกลับ เพื่อสรุปยอดอีกครั้งจากทางเรา"</h4>

                    <Panel>
                        <Col xs={2} sm={1} md={1} lg={1}>
                            <h3>1.</h3>
                        </Col>
                        <Col xs={10} sm={11} md={11} lg={11}>
                            <h4>รอการยืนยันยอดเงินทั้งหมดจากเจ้าหน้าที่</h4>
                            <h5 style={{ color: '#898989' }}>ยอดชำระที่ท่านเห็นในหน้าก่อนนี้ อาจจะไม่ใช่ยอดสุดท้าย เนื่องจากสินค้าอาจมีการเปลี่ยนแปลงน้ำหนัก หรือมีการแกว่งของน้ำหนัก ทำให้ท่านต้องรอการยืนยันยอดจากเจ้าหน้าที่ส่งสด</h5>
                        </Col>
                    </Panel>

                    {/* <Panel>
                        <Col xs={2} sm={1} md={1} lg={1}>
                            <h3>2.</h3>
                        </Col>
                        <Col xs={10} sm={11} md={11} lg={11}>
                            <h4>โอนเงิน</h4>
                            <h5 style={{ color: '#898989' }}>กดที่ภาพเพื่อขยาย</h5>
                            <div>
                                <Lightbox
                                    images={[{ src: "../../static/images/bankaccountmobile.jpg" }]}
                                    isOpen={this.state.lightboxIsOpen}
                                    onClose={this.closeLightbox}
                                    backdropClosesModal={true}
                                    width={1024}
                                />
                                <img className="img"
                                    onClick={this.openLightbox}
                                    style={{ width: '100%', cursor: 'pointer' }}
                                    src="../../static/images/bankaccountmobile.jpg" />
                            </div>
                        </Col>
                    </Panel> */}

                    <Panel>
                        <Col xs={2} sm={1} md={1} lg={1}>
                            <h3>2.</h3>
                        </Col>
                        <Col xs={10} sm={11} md={11} lg={11}>
                            <h4>แอดไลน์ @songsod เพื่อติดต่อกับพนักงานได้เลย</h4>
                            <div><img style={{ width: 35 }} src='../static/images/SongSodChat.png' /></div>
                            <h5 style={{ color: '#898989' }}>แอดไลน์ @songsod เพื่อติดต่อกับพนักงาน</h5>

                        </Col>
                    </Panel>
                    {this.state.loading == false ?
                        <button style={{width: 250, height: 60, fontSize: '20px !important'}} className='btn btn-success pull-right' onClick={() => { this.createOrderCT('QRCODE') }}>กดเพื่อยืนยันการสั่งซื้อสินค้า</button>
                        : <div className='loader'></div>
                    }
                </Panel>
            )
        }
        if (this.state.tabSelect == '3' ) {
            return (
                <Panel>
                    <h4 style={{ color: '#f57224 !important', marginTop: 20, marginBottom: 20, textAlign: 'center' }}>"ราคาสินค้าอาจมีการเปลี่ยนแปลง *และยังไม่รวมค่าจัดส่ง อย่าเพิ่งโอนเงิน กรุณารอการติดต่อกลับ เพื่อสรุปยอดอีกครั้งจากทางเรา"</h4>

                    <Panel>
                        <Col xs={2} sm={1} md={1} lg={1}>
                            <h3>1.</h3>
                        </Col>
                        <Col xs={10} sm={11} md={11} lg={11}>
                            <h4>รอการยืนยันยอดเงินทั้งหมดจากเจ้าหน้าที่</h4>
                            <h5 style={{ color: '#898989' }}>ยอดชำระที่ท่านเห็นในหน้าก่อนนี้ อาจจะไม่ใช่ยอดสุดท้าย เนื่องจากสินค้าอาจมีการเปลี่ยนแปลงน้ำหนัก หรือมีการแกว่งของน้ำหนัก ทำให้ท่านต้องรอการยืนยันยอดจากเจ้าหน้าที่ส่งสด</h5>
                        </Col>
                    </Panel>

                    {/* <Panel>
                        <Col xs={2} sm={1} md={1} lg={1}>
                            <h3>2.</h3>
                        </Col>
                        <Col xs={10} sm={11} md={11} lg={11}>
                            <h4>โอนเงิน</h4>
                            <h5 style={{ color: '#898989' }}>กดที่ภาพเพื่อขยาย</h5>
                            <div>
                                <Lightbox
                                    images={[{ src: "../../static/images/bankaccountmobile.jpg" }]}
                                    isOpen={this.state.lightboxIsOpen}
                                    onClose={this.closeLightbox}
                                    backdropClosesModal={true}
                                    width={1024}
                                />
                                <img className="img"
                                    onClick={this.openLightbox}
                                    style={{ width: '100%', cursor: 'pointer' }}
                                    src="../../static/images/bankaccountmobile.jpg" />
                            </div>
                        </Col>
                    </Panel> */}

                    <Panel>
                        <Col xs={2} sm={1} md={1} lg={1}>
                            <h3>2.</h3>
                        </Col>
                        <Col xs={10} sm={11} md={11} lg={11}>
                            <h4>แอดไลน์ @songsod เพื่อติดต่อกับพนักงานได้เลย</h4>
                            <div><img style={{ width: 35 }} src='../static/images/SongSodChat.png' /></div>
                            <h5 style={{ color: '#898989' }}>แอดไลน์ @songsod เพื่อติดต่อกับพนักงาน</h5>

                        </Col>
                    </Panel>
                    {this.state.loading == false ?
                        <button style={{width: 250, height: 60, fontSize: '20px !important'}} className='btn btn-success pull-right' onClick={() => { this.createOrderCT('BANKTRANSFER') }}>กดเพื่อยืนยันการสั่งซื้อสินค้า</button>
                        : <div className='loader'></div>
                    }
                </Panel>
            )
        }
        else {
            return (
                <div>
                    <h4 style={{ textAlign: 'center' }}>กรุณาเลือกช่องทางการชำระเงิน</h4>
                    <br />
                </div>
            )
        }
    }

    createOrderCT(payment_method) {
        this.setState({ payment_method: payment_method, loading: true })
        this.checkPrice()
    }

    render() {
        // console.log(this.props.customer_credit_card)
        // this.checkoutOmiseCallback()
        // console.log('total', this.getTotalPrice())
        // console.log(this.getFinalPrice());
        if (this.state.isLogin) {
            return (
                <div>
                    <NavHeader history={this.props.history} />
                    <SubMenu ref={d => this.submenu = d} history={this.props.history} />
                    <div className="container main-bg">
                        <Col md={3} sm={0} xs={0}>
                        </Col>

                        <Col md={6} sm={12} xs={12}>
                            <div>
                                <Stepper
                                    activeColor='#F37232'
                                    completeColor='#F37232'
                                    circleFontSize={14}
                                    circleTop={15}
                                    size={30}
                                    steps={[{ title: 'ตรวจสอบรายการสินค้าในตะกร้า' },
                                    { title: 'เลือกวิธีจัดส่ง' },
                                    { title: 'วิธีชำระเงิน' },
                                    { title: 'สั่งซื้อเรียบร้อย' }]}
                                    activeStep={2} />
                            </div>
                            <h2><strong>วิธีการชำระเงิน</strong></h2>
                            {this.renderTab()}
                            {this.renderForm()}
                        </Col>
                    </div>
                    <Footer history={this.props.history} />

                    {/* <Modal show={this.state.showModal}>
                        <Modal.Header>
                            <Modal.Title>กรุณาเลือกช่องทางการชำระเงิน</Modal.Title>
                        </Modal.Header>
                        <Modal.Body style={{ textAlign: 'center' }}>
                            {this.renderTab()}
                        </Modal.Body>
                    </Modal> */}
                </div>
            )
        }
        else {
            return (
                <div className='container'>
                    <h1>loading...</h1>
                </div>
            )
        }
    }
}

function mapStateToProps(state) {
    return {
        cart_products: state.cart_products_reducer,
        cart_extraproducts: state.cart_extraproducts_reducer,
        check_cart_products_price_response: state.check_cart_products_price_response_reducer,
        payment_stage: state.payment_stage_reducer,
        delivery_time: state.delivery_time_reducer,
        delivery_charge: state.delivery_charge_reducer,
        customer_credit_card: state.customer_credit_card_reducer,
        discount: state.promocodeReducer,
    }
}

export default (connect(mapStateToProps, { checkoutOmise, createOrder, updateCartProducts, checkCartProductsPrice, setPaymentStage, setDeliveryTime, createCustomerOmise, getCreditCardByPhoneNumber, clearCreditCard, clearCheckPriceResponse, updateCartExtraProducts })(PagePayment))



// WEBPACK FOOTER //
// ./src/components/page_payment.js